import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import { Pagination, SearchTable, TableBody, TableHeader } from '.';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../../Utils/table';
import { selectPaymentData } from '../../Selectors/JobworkSelector/JobworkSelect';
import { fetchPaymentRegister } from '../../../Store/PHPSlice/Payment/paymentApi';
import TitleBar from '../../TitleBar';
import { jobworkMenu } from '../../TitleList';



const PaymentRegister = () => {
    const dispatch = useDispatch();
    const paydata = useSelector(selectPaymentData);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');
    useEffect(() => {
        dispatch(fetchPaymentRegister());
    }, [dispatch]);

    if (!paydata) {
        return <h1>Loading...</h1>;
    }


    const compData = Array.isArray(paydata.data) ? paydata.data.map((item, index) => (
        {
            id: item.ID,
            dt: item.dt,
            empId: item.empId,
            empNm: item.empNm,
            jobId: item.jobId,
            payMemo: item.payMemo,
            fdt: item.fdt,
            tdt: item.tdt,
            netamt: item.netamt,
            dedamt: item.dedamt,
            clothamt: item.clothamt,
            payableamt: item.payableamt,
            pay_mode: item.pay_mode,
            bnk_nm: item.bnk_nm,
            chq_no: item.chq_no,
            nar: item.nar,
            sts: item.sts,
            paidamt: item.paidamt,
            balamt: item.balamt,
            serialNumber: index + 1
        }
    )) : [];


    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };
    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };

    const handlePrevPage = () => {
        if (currentPage !== firstIndex) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextpage = () => {
        if (currentPage !== lastIndex) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
        setCurrentPage(1); // Reset current page when records per page changes
    };

    const totalCount = compData && compData.length;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);
    const renderPaginationButtons = () => {
        let start = Math.max(1, currentPage - 5);
        let end = Math.min(npages, start + 9);

        if (end - start < 9) {
            start = Math.max(1, end - 9);
        }

        return numbers.slice(start - 1, end).map((n) => (

            <button key={n} className={`page-link ${currentPage === n - 1 ? 'active' : ''}`} onClick={() => handleChangeCPage(n - 1)}>{n}</button>
        ));
    };

    const handleFilterByName = (event) => {
        setPage(0);
        const value = event.target.value.trim();
        setFilterName(event.target.value);

    };
    // const dataFiltered = applyFilter({
    //     inputData: compData,
    //     comparator: getComparator(order, orderBy),

    // });
    // const notFound = !dataFiltered.length;

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item.payMemo.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.empNm.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.dt.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.chq_no.toLowerCase().includes(searchTerm.toLowerCase())
    );


    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),

    });

    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };


    return (
        <>

            <TitleBar data={jobworkMenu} />
            <div style={{ margin: '2% 0%' }}>
                <h2>Payment Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>


                            {/* <SearchTable handleRecordsPerPageChange={handleRecordsPerPageChange}
                                filterName={filterName}
                                handleFilterByName={handleFilterByName} /> */}

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                            />


                            <TableContainer style={{ marginTop: '2%', border: '1px solid #ccc' }}>
                                <Table>
                                    <TableHeader
                                        headCells={
                                            [
                                                { id: 'serialNumber', label: 'Sr.No' },
                                                { id: 'dt', label: 'Date' },
                                                { id: 'payMemo', label: 'Payment No.' },
                                                { id: 'fdt', label: 'From-To Date' },
                                                { id: 'empNm', label: 'Employee' },
                                                { id: 'payableamt', label: 'Payable Amt.' },
                                                { id: 'paidamt', label: 'Paid Amt.' },
                                                { id: 'balamt', label: 'Balance Amt.' },
                                                { id: 'paymode', label: 'Payment Mode' },
                                                { id: 'bnk_nm', label: 'Bank Name' },
                                                { id: 'chq_no', label: 'Transaction No.' },
                                                { id: 'nar', label: 'Naration' },
                                                { id: '', label: 'Delete' },
                                            ]
                                        }
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>
                                        {displayedData.map((row, index) => (
                                            <TableBody
                                                key={row.srNo}
                                                id={row.id}
                                                dt={row.dt}
                                                payMemo={row.payMemo}
                                                empId={row.empId}
                                                empNm={row.empNm}
                                                fdt={row.fdt}
                                                tdt={row.tdt}
                                                payableamt={row.payableamt}
                                                pay_mode={row.pay_mode}
                                                bnk_nm={row.bnk_nm}
                                                chq_no={row.chq_no}
                                                nar={row.nar}
                                                paidamt={row.paidamt}
                                                balamt={row.balamt}
                                                serialNumber={row.serialNumber}
                                                selected={selected.indexOf(row.companyName) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />
                                        ))}
                                    </tbody>
                                </Table>
                            </TableContainer>


                            {/* <Pagination
                                currentPage={currentPage}
                                npages={npages}
                                handlePrevPage={handlePrevPage}
                                handleNextpage={handleNextpage}
                                setCurrentPage={setCurrentPage}
                                renderPaginationButtons={renderPaginationButtons}
                                totalCount={totalCount}
                            /> */}

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default PaymentRegister;
